import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    SwipeableRowHoverTooltipConstantType,
    SwipeableRowHoverDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../../../types";
import {
    getCornersStyle
} from "../../../../helpers/theme/corner";
import {
    getMotionTransition
} from "../../../../helpers/motion";
import {
    webStyle
} from "../../../../utils";

export const getSwipeableRowHoverTooltip = ({
    action
}: SwipeableRowHoverTooltipConstantType): string => {
    return action.shortcut ? `${action.title} · ${action.shortcut}` : action.title;
};

const stylesheet = StyleSheet.create({
    container: {
        ...StyleSheet.absoluteFill,
        justifyContent: "flex-end",
        pointerEvents: "box-none",
        alignItems: "center",
        flexDirection: "row"
    },
    bar: {
        alignItems: "center",
        flexDirection: "row",
        alignSelf: "stretch"
    }
});

export const useStyles = ({
    isReduceMotionEnabled,
    controlHeights,
    borderRadius,
    shapeConfigs,
    durations,
    isVisible,
    isCoarse,
    colors,
    spaces
}: SwipeableRowHoverDynamicStyleType) => {
    const barRadius = Math.max(0, borderRadius - spaces.spacingSm);

    const styles = {
        bar: {
            backgroundColor: colors.content.container.raised,
            ...getCornersStyle({
                corners: {
                    borderStartEndRadius: barRadius,
                    borderEndEndRadius: barRadius
                },
                shapeConfigs
            }),
            paddingStart: spaces.spacingSm,
            opacity: isVisible ? 1 : 0,
            gap: spaces.spacingXxs,
            ...webStyle(getMotionTransition({
                isReduceMotionEnabled,
                intent: "hover",
                properties: [
                    "opacity"
                ],
                durations
            }))
        } as Mutable<ViewStyle>,
        layer: {
            ...getCornersStyle({
                corners: {
                    borderStartEndRadius: barRadius,
                    borderEndEndRadius: barRadius
                },
                shapeConfigs
            })
        } as Mutable<ViewStyle>,
        container: {
            paddingEnd: spaces.spacingSm
        } as Mutable<ViewStyle>
    };

    if(isCoarse) {
        styles.bar.backgroundColor = "transparent";
        styles.bar.opacity = 1;
        styles.bar.paddingStart = 0;
        styles.bar.minWidth = controlHeights.small;
    }

    return styles;
};
export default stylesheet;
